import WithGASetup from '../WithGASetup';
import ExpireToken from './ExpireToken';

export default WithGASetup(ExpireToken);
